import Stacked100_Line_Charts from "./Excel_components/Stacked100_Line_Charts";
import Above_and_Below_Average from "./Excel_components/Above_and_Below_Average";
import Addition_Operator from "./Excel_components/Addition_Operator";
import AND from "./Excel_components/AND";
import AVERAGE from "./Excel_components/AVERAGE";
import AVERAGEIF from "./Excel_components/AVERAGEIF";
import AVERAGEIFS from "./Excel_components/AVERAGEIFS";
import Bar_Charts from "./Excel_components/Bar_Charts";
import Case_Poke_Mart_Styling from "./Excel_components/Case_Poke_Mart_Styling";
import Case_Poke_Mart from "./Excel_components/Case_Poke_Mart";
import Charts from "./Excel_components/Charts";
import Column_Charts from "./Excel_components/Column_Charts";
import CONCAT from "./Excel_components/CONCAT";
import Converting_a_Table_to_Range from "./Excel_components/Converting_a_Table_to_Range";
import Convert_Time_to_Seconds from "./Excel_components/Convert_Time_to_Seconds";
import COUNT from "./Excel_components/COUNT";
import COUNTA from "./Excel_components/COUNTA";
import COUNTBLANK from "./Excel_components/COUNTBLANK";
import COUNTIF from "./Excel_components/COUNTIF";
import COUNTIFS from "./Excel_components/COUNTIFS";
import Difference_Between_Times from "./Excel_components/Difference_Between_Times";
import Division_Operator from "./Excel_components/Division_Operator";
import Double_Click_to_Fill from "./Excel_components/Double_Click_to_Fill";
import Excel_Absolute_Reference from "./Excel_components/Excel_Absolute_Reference";
import Excel_Add_Cells from "./Excel_components/Excel_Add_Cells";
import Excel_Arithmetic_Operators from "./Excel_components/Excel_Arithmetic_Operators";
import Excel_Certificate from "./Excel_components/Excel_Certificate";
import Excel_Charts from "./Excel_components/Excel_Charts";
import Excel_Charts_Customization from "./Excel_components/Excel_Charts_Customization";
import Excel_Color_Scales from "./Excel_components/Excel_Color_Scales";
import Excel_Conditional_Format from "./Excel_components/Excel_Conditional_Format";
import Excel_Data_Bars from "./Excel_components/Excel_Data_Bars";
import Excel_Delete_Cells from "./Excel_components/Excel_Delete_Cells";

import Excel_Fill from "./Excel_components/Excel_Fill";
import Excel_Filter from "./Excel_components/Excel_Filter";
import Excel_Formatting from "./Excel_components/Excel_Formatting";
import Excel_Format_Borders from "./Excel_components/Excel_Format_Borders";
import Excel_Format_Colors from "./Excel_components/Excel_Format_Colors";
import Excel_Format_Fonts from "./Excel_components/Excel_Format_Fonts";
import Excel_Format_Grids from "./Excel_components/Excel_Format_Grids";
import Excel_Format_Numbers from "./Excel_components/Excel_Format_Numbers";
import Excel_Format_Painter from "./Excel_components/Excel_Format_Painter";
import Excel_Format_Settings from "./Excel_components/Excel_Format_Settings";
import Excel_Formulas from "./Excel_components/Excel_Formulas";
import Excel_Functions from "./Excel_components/Excel_Functions";
import Excel_Get_Started from "./Excel_components/Excel_Get_Started";
import Excel_Highlight_Cell_Rules from "./Excel_components/Excel_Highlight_Cell_Rules";
import Excel_HOME from "./Excel_components/Excel_HOME";
import Excel_Icon_Sets from "./Excel_components/Excel_Icon_Sets";
import Excel_Introduction from "./Excel_components/Excel_Introduction";
import Excel_Keyboard_Shortcuts from "./Excel_components/Excel_Keyboard_Shortcuts";
import Excel_Manage_Rules_CF from "./Excel_components/Excel_Manage_Rules_CF";
import Excel_Move_Cells from "./Excel_components/Excel_Move_Cells";
import Excel_Overview from "./Excel_components/Excel_Overview";
import Excel_Parentheses from "./Excel_components/Excel_Parentheses";
import Excel_Ranges from "./Excel_components/Excel_Ranges";
import Excel_Relative_Reference from "./Excel_components/Excel_Relative_Reference";
import Excel_Sort from "./Excel_components/Excel_Sort";
import Excel_Study_Plan from "./Excel_components/Excel_Study_Plan";
import Excel_Syllabus from "./Excel_components/Excel_Syllabus";
import Excel_Synta from "./Excel_components/Excel_Synta";
import Excel_Tables from "./Excel_components/Excel_Tables";
import Excel_Top_Bottom_Rules from "./Excel_components/Excel_Top_Bottom_Rules";
import Excel_Training from "./Excel_components/Excel_Training";
import Excel_Undo_Redo from "./Excel_components/Excel_Undo_Redo";
import Filling from "./Excel_components/Filling";
import HCR_Between from "./Excel_components/HCR_Between";
import HCR_Date_Occurring from "./Excel_components/HCR_Date_Occurring";
import HCR_Greater_Than from "./Excel_components/HCR_Greater_Than";
import HCR_Less_Than from "./Excel_components/HCR_Less_Than";
import HCR_Unique_Values from "./Excel_components/HCR_Unique_Values";
import IF from "./Excel_components/IF";
import IFS from "./Excel_components/IFS";
import LEFT from "./Excel_components/LEFT";
import Line_Charts from "./Excel_components/Line_Charts";
import LOWER from "./Excel_components/LOWER";
import MA from "./Excel_components/MA";
import MEDIAN from "./Excel_components/MEDIAN";
import MIN from "./Excel_components/MIN";
import MODE from "./Excel_components/MODE";
import Multiplication_Operator from "./Excel_components/Multiplication_Operator";
import NPV from "./Excel_components/NPV";
import NPV_Net_Present_Value from "./Excel_components/NPV_Net_Present_Value";
import OR from "./Excel_components/OR";
import Pie_Charts from "./Excel_components/Pie_Charts";
import Radar_Charts from "./Excel_components/Radar_Charts";
import RAND from "./Excel_components/RAND";
import Remove_Duplicates from "./Excel_components/Remove_Duplicates";
import Removing_Duplicates from "./Excel_components/Removing_Duplicates";
import RIGHT from "./Excel_components/RIGHT";
import Stacked_Bar_Charts from "./Excel_components/Stacked_Bar_Charts";
import Stacked_Column_Charts from "./Excel_components/Stacked_Column_Charts";
import Stacked_Line_Charts from "./Excel_components/Stacked_Line_Charts";
import STDEV_P from "./Excel_components/STDEV_P";
import STDEV_S from "./Excel_components/STDEV_S";
import Subtraction_Operator from "./Excel_components/Subtraction_Operator";
import SUM from "./Excel_components/SUM";
import SUMIF from "./Excel_components/SUMIF";
import SUMIFS from "./Excel_components/SUMIFS";
import Tables from "./Excel_components/Tables";
import Table_Design from "./Excel_components/Table_Design";
import Table_Pivot_Intro from "./Excel_components/Table_Pivot_Intro";
import Table_Resizing from "./Excel_components/Table_Resizing";
import Table_Style from "./Excel_components/Table_Style";
import Top_Bottom_Rules from "./Excel_components/Top_Bottom_Rules";
import TRIM from "./Excel_components/TRIM";
import VLOOKUP from "./Excel_components/VLOOKUP";
import XOR from "./Excel_components/XOR";

const AllExcelComponents = {
  "<100%_Stacked_Line_Charts />": Stacked100_Line_Charts,
  "<Above_and_Below_Average />": Above_and_Below_Average,
  "<Addition_Operator />": Addition_Operator,
  "<AND />": AND,
  "<AVERAGE />": AVERAGE,
  "<AVERAGEIF />": AVERAGEIF,
  "<AVERAGEIFS />": AVERAGEIFS,
  "<Bar_Charts />": Bar_Charts,
  "<Case_Poke_Mart_Styling />": Case_Poke_Mart_Styling,
  "<Case_Poke_Mart />": Case_Poke_Mart,
  "<Charts />": Charts,
  "<Column_Charts />": Column_Charts,
  "<CONCAT />": CONCAT,
  "<Converting_a_Table_to_Range />": Converting_a_Table_to_Range,
  "<Convert_Time_to_Seconds />": Convert_Time_to_Seconds,
  "<COUNT />": COUNT,
  "<COUNTA />": COUNTA,
  "<COUNTBLANK />": COUNTBLANK,
  "<COUNTIF />": COUNTIF,
  "<COUNTIFS />": COUNTIFS,
  "<Difference_Between_Times />": Difference_Between_Times,
  "<Division_Operator />": Division_Operator,
  "<Double_Click_to_Fill />": Double_Click_to_Fill,
  "<Excel_Absolute_Reference />": Excel_Absolute_Reference,
  "<Excel_Add_Cells />": Excel_Add_Cells,
  "<Excel_Arithmetic_Operators />": Excel_Arithmetic_Operators,
  "<Excel_Certificate />": Excel_Certificate,
  "<Excel_Charts />": Excel_Charts,
  "<Excel_Charts_Customization />": Excel_Charts_Customization,
  "<Excel_Color_Scales />": Excel_Color_Scales,
  "<Excel_Conditional_Format />": Excel_Conditional_Format,
  "<Excel_Data_Bars />": Excel_Data_Bars,
  "<Excel_Delete_Cells />": Excel_Delete_Cells,

  "<Excel_Fill />": Excel_Fill,
  "<Excel_Filter />": Excel_Filter,
  "<Excel_Formatting />": Excel_Formatting,
  "<Excel_Format_Borders />": Excel_Format_Borders,
  "<Excel_Format_Colors />": Excel_Format_Colors,
  "<Excel_Format_Fonts />": Excel_Format_Fonts,
  "<Excel_Format_Grids />": Excel_Format_Grids,
  "<Excel_Format_Numbers />": Excel_Format_Numbers,
  "<Excel_Format_Painter />": Excel_Format_Painter,
  "<Excel_Format_Settings />": Excel_Format_Settings,
  "<Excel_Formulas />": Excel_Formulas,
  "<Excel_Functions />": Excel_Functions,
  "<Excel_Get_Started />": Excel_Get_Started,
  "<Excel_Highlight_Cell_Rules />": Excel_Highlight_Cell_Rules,
  "<Excel_HOME />": Excel_HOME,
  "<Excel_Icon_Sets />": Excel_Icon_Sets,
  "<Excel_Introduction />": Excel_Introduction,
  "<Excel_Keyboard_Shortcuts />": Excel_Keyboard_Shortcuts,
  "<Excel_Manage_Rules_CF />": Excel_Manage_Rules_CF,
  "<Excel_Move_Cells />": Excel_Move_Cells,
  "<Excel_Overview />": Excel_Overview,
  "<Excel_Parentheses />": Excel_Parentheses,
  "<Excel_Ranges />": Excel_Ranges,
  "<Excel_Relative_Reference />": Excel_Relative_Reference,
  "<Excel_Sort />": Excel_Sort,
  "<Excel_Study_Plan />": Excel_Study_Plan,
  "<Excel_Syllabus />": Excel_Syllabus,
  "<Excel_Synta />": Excel_Synta,
  "<Excel_Tables />": Excel_Tables,
  "<Excel_Top_Bottom_Rules />": Excel_Top_Bottom_Rules,
  "<Excel_Training />": Excel_Training,
  "<Excel_Undo_Redo />": Excel_Undo_Redo,
  "<Filling />": Filling,
  "<HCR_Between />": HCR_Between,
  "<HCR_Date_Occurring />": HCR_Date_Occurring,

  "<HCR_Greater_Than />": HCR_Greater_Than,
  "<HCR_Less_Than />": HCR_Less_Than,
  "<HCR_Unique_Values />": HCR_Unique_Values,

  "<IF />": IF,
  "<IFS />": IFS,
  "<LEFT />": LEFT,
  "<Line_Charts />": Line_Charts,
  "<LOWER />": LOWER,
  "<MA />": MA,
  "<MEDIAN />": MEDIAN,
  "<MIN />": MIN,
  "<MODE />": MODE,
  "<Multiplication_Operator />": Multiplication_Operator,
  "<NPV />": NPV,
  "<NPV_Net_Present_Value />": NPV_Net_Present_Value,
  "<OR />": OR,
  "<Pie_Charts />": Pie_Charts,
  "<Radar_Charts />": Radar_Charts,
  "<RAND />": RAND,
  "<Remove_Duplicates />": Remove_Duplicates,
  "<Removing_Duplicates />": Removing_Duplicates,
  "<RIGHT />": RIGHT,
  "<Stacked_Bar_Charts />": Stacked_Bar_Charts,
  "<Stacked_Column_Charts />": Stacked_Column_Charts,
  "<Stacked_Line_Charts />": Stacked_Line_Charts,
  "<STDEV_P />": STDEV_P,
  "<STDEV_S />": STDEV_S,
  "<Subtraction_Operator />": Subtraction_Operator,
  "<SUM />": SUM,
  "<SUMIF />": SUMIF,
  "<SUMIFS />": SUMIFS,
  "<Tables />": Tables,
  "<Table_Design />": Table_Design,
  "<Table_Pivot_Intro />": Table_Pivot_Intro,
  "<Table_Resizing />": Table_Resizing,
  "<Table_Style />": Table_Style,
  "<Top_Bottom_Rules />": Top_Bottom_Rules,
  "<TRIM />": TRIM,
  "<VLOOKUP />": VLOOKUP,
  "<XOR />": XOR,
};

export default AllExcelComponents;
